import React from "react";
import Layout from "../../layout/components/Layout";
import Body from "../../layout/components/Body";
import Middle from "../../layout/components/Col/Middle";
import Footer from "../../layout/components/Footer";
import Header from "../../layout/components/Header";
import MobileMenu from "../../layout/components/MobileMenu";
import SearchOverlay from "../../search/components/SearchOverlay";
import i18next from "i18next";
import { Link, useParams } from "react-router-dom";
import { PARAMS } from "../../router/constants/Params";
import { scrollTop } from "../../layout/scripts/scroll";
import { AccountFallback } from "../../account/components/AccountFallback";
import { Customer } from "../../commercelayer/vo/customers";
import { useSelector } from "react-redux";
import State from "../../state/vo/State";
import { PATH } from "../../router/constants/Path";
import ConsignmentStockBreadcrumb from "./ConsignmentStockBreadcrumb";
import { getLangCountry } from "../../router/scripts/link";
import Shipping from "../../checkout/components/Shipping";
import Payment from "../../checkout/components/Payment";
import ConsignmentStock from "../../state/vo/ConsignmentStock";
import { useInitConsignmentStockCheckout } from "consignment-stock/hooks";
import useInitCustomer from "../../account/hooks/useInitCustomer";
import Navigation from "../../account/components/Navigation";

const ConsignmentStockShippingPayment: React.FC = () => {
  const params = useParams();
  const consignmentStockOrderId = params[PARAMS.ORDER_ID];
  const consignmentStock: ConsignmentStock = useSelector((state: State) => state.consignmentStock);
  const customer: Customer | null = useSelector((state: State) => state.account.customer);

  useInitCustomer();
  useInitConsignmentStockCheckout();

  if (customer === null) {
    return <AccountFallback />;
  }

  return (
    <Layout>
      <Header />
      <MobileMenu />
      <SearchOverlay />
      <Body>
        <Navigation path={PATH.CONSIGNMENT_STOCK} />
        <Middle>
          <h1 className="col-title">{i18next.t("CONSIGNMENT STOCK")}</h1>
          <ConsignmentStockBreadcrumb activeStep={2} />

          <div className="grid-wrap grid-wrap--checkout">
            <Shipping
              cart={consignmentStock.order}
              orderUpdating={consignmentStock.checkout.orderUpdating}
            />
            <Payment
              cart={consignmentStock.order}
              orderUpdating={consignmentStock.checkout.orderUpdating}
            />
          </div>

          <div className="btn-wrap btn-wrap--line">
            <div className="grid-1-2">
              <Link
                to={`${getLangCountry()}/${PATH.ACCOUNT}/${customer.id}/${PATH.CONSIGNMENT_STOCK}`}
                className="btn transparent"
                role="button"
                tabIndex={0}
                onClick={() => scrollTop()}
              >
                <span className="btn__text">{i18next.t("PRODUCT SELECTION")}</span>
              </Link>
            </div>
            <div className="grid-1-2 grid-1-2--right">
              <Link
                className="btn"
                aria-disabled="false"
                role="button"
                tabIndex={0}
                to={`${getLangCountry()}/${PATH.ACCOUNT}/${customer.id}/${
                  PATH.CONSIGNMENT_STOCK
                }/${consignmentStockOrderId}/${PATH.VERIFICATION}`}
                onClick={() => scrollTop()}
              >
                <span className="btn__text">{i18next.t("VERIFICATION")}</span>
              </Link>
            </div>
          </div>
        </Middle>
      </Body>
      <Footer />
    </Layout>
  );
};

export default ConsignmentStockShippingPayment;
